<template>
  <div style="width: 60%">
    <div class="login-form login-signin">
      <b-row>
        <b-col>
          <b-form-group
            id="revenda"
            label-for="revenda"
            label="Sou parceiro Zucchetti"
            class="font-size-h6 font-weight-bolder text-dark"
          >
            <span class="switch switch-icon">
              <label>
                <input
                  type="checkbox"
                  :disabled="true"
                  v-model="isRevenda"
                  :checked="isRevenda"
                />
                <span></span>
              </label>
            </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <b-form-group
          id="example-input-group-1"
          label=""
          label-for="input-email"
        >
          <template v-if="!isRevenda">
            <label class="font-size-h6 font-weight-bolder text-dark"
              >E-mail</label
            >
            <b-form-input
              class="form-control form-control-solid h-auto py-5 px-6"
              id="input-email"
              name="input-email"
              v-model="form.email"
              aria-describedby="input-1-live-feedback"
            ></b-form-input>
          </template>
          <template v-else>
            <label class="font-size-h6 font-weight-bolder text-dark"
              >CNPJ / CPF</label
            >
            <b-form-input
              class="form-control form-control-solid h-auto py-5 px-6"
              id="example-input-1"
              name="example-input-1"
              :value="form.cnpj"
              @input="onDocumentInput"
              maxlength="18"
              placeholder=""
              style="text-transform: uppercase"
              aria-describedby="input-1-live-feedback"
            ></b-form-input>
          </template>
        </b-form-group>
        <b-form-group
          id="example-input-group-2"
          label=""
          label-for="input-senha"
        >
          <label class="font-size-h6 font-weight-bolder text-dark">Senha</label>
          <b-form-input
            class="form-control form-control-solid h-auto py-5 px-6"
            type="password"
            id="input-senha"
            name="input-senha"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            aria-describedby="input-2-live-feedback"
          ></b-form-input>
          <b-form-invalid-feedback id="input-2-live-feedback">
            Campo senha é obrigatório.
          </b-form-invalid-feedback>
        </b-form-group>
        <div
          class="form-group d-flex flex-wrap justify-content-between align-items-center"
        >
          <button
            ref="kt_login_submit"
            class="btn btn-primary font-weight-bold px-9 py-4 my-3 font-size-3"
          >
            Continuar
          </button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { LOGIN } from "@/core/services/store/auth.module";
import { validationMixin } from "vuelidate";
import { minLength, required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      isRevenda: true,
      form: {
        email: "",
        // cnpj: "26.115.879/0001-00",
        cnpj: "",
        // password: "gdb@c4"
        password: "",
      },
    };
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(3),
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
        cnpj: null,
        password: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onDocumentInput(value) {
      const raw = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      const hasLetter = /[A-Z]/.test(raw);

      if (!hasLetter && raw.length <= 11) {
        const n = raw;
        if (n.length <= 3) {
          this.form.cnpj = n;
        } else if (n.length <= 6) {
          this.form.cnpj = `${n.slice(0, 3)}.${n.slice(3)}`;
        } else if (n.length <= 9) {
          this.form.cnpj = `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6)}`;
        } else {
          this.form.cnpj = `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6, 9)}-${n.slice(9, 11)}`;
        }
      } else {
        const prefix = raw.slice(0, 12);
        const suffix = raw.slice(12, 14).replace(/[^0-9]/g, "");
        const n = prefix + suffix;
        if (n.length <= 2) {
          this.form.cnpj = n;
        } else if (n.length <= 5) {
          this.form.cnpj = `${n.slice(0, 2)}.${n.slice(2)}`;
        } else if (n.length <= 8) {
          this.form.cnpj = `${n.slice(0, 2)}.${n.slice(2, 5)}.${n.slice(5)}`;
        } else if (n.length <= 12) {
          this.form.cnpj = `${n.slice(0, 2)}.${n.slice(2, 5)}.${n.slice(5, 8)}/${n.slice(8)}`;
        } else {
          this.form.cnpj = `${n.slice(0, 2)}.${n.slice(2, 5)}.${n.slice(5, 8)}/${n.slice(8, 12)}-${n.slice(12)}`;
        }
      }
    },
    async onSubmit() {
      const submitButton = this.$refs["kt_login_submit"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          return;
        }

        const formData = {};

        if (this.isRevenda) {
          formData.cnpj = this.form.cnpj;
        } else {
          formData.email = this.form.email;
        }

        formData.password = this.$v.form.password.$model;

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        const dataUser = await this.$store.dispatch(LOGIN, formData);

        if (dataUser.INTERNO) {
          this.$router.push("/configuracoes/renovacoes/valor");
          return;
        }

        this.$router.push("/");
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right",
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
